'use client';

import { useRef, useState } from 'react';

import Classes from './style.module.scss';

import { mediaURL } from '@/lib/sslByDomain';

import NextImage from '../NextImage';

interface VideoPlayerPropsInferface {
  videoFileURL: string;
  poster?: string;
}

export default function VideoPlayer(props: VideoPlayerPropsInferface) {
  const { videoFileURL, poster } = props;
  const videoRef = useRef<HTMLIFrameElement | null>(null);
  const [loadPlayer, setLoadPlayer] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <div>
      {!loadPlayer ? (
        <div
          className='video-js vjs-big-play-centered section-entrepreneurship-video group relative relative z-10 flex aspect-video items-center justify-center overflow-hidden rounded-2xl'
          tabIndex={-1}
          role='region'
          lang='en'
          translate='no'
          aria-label='Video Player'
        >
          {poster && (
            <div
              className='vjs-poster pointer-events-none'
              aria-disabled='false'
            >
              <NextImage
                useSkeleton
                fill
                alt='The CERN Venture Connect programme'
                sizes='(max-width: 1200px) 1200vw, 50vw'
                tabIndex={-1}
                src={mediaURL(poster)}
              />
            </div>
          )}
          <button
            className='vjs-big-play-button z-10 m-0 flex h-full w-full items-center justify-center border-none bg-primary-900 bg-opacity-50 p-4 transition-all duration-200 ease-linear group-hover:bg-opacity-75'
            type='button'
            title='Play Video'
            aria-disabled='false'
            onClick={() => {
              setLoading(true);
              setLoadPlayer(true);
            }}
          >
            <span
              className='vjs-icon-placeholder pointer-events-none flex h-[3.75rem] w-[3.75rem] md:h-[7.5rem] md:w-[7.5rem]'
              aria-hidden='true'
            >
              <NextImage
                src='/images/icon-play.svg'
                alt='play video'
                width='120'
                height='120'
              />
            </span>
            <span
              className='vjs-control-text pointer-events-none invisible absolute -z-10 opacity-0'
              aria-live='polite'
            >
              Play Video
            </span>
          </button>
        </div>
      ) : (
        <div className='section-entrepreneurship__iframe aspect-video overflow-hidden rounded-2xl bg-primary-950'>
          <iframe
            src={videoFileURL}
            className='relative z-10 aspect-video w-full rounded-2xl bg-primary-950'
            allow='fullscreen'
            onLoad={() => {
              setLoading(false);
              setLoadPlayer(true);
            }}
            ref={videoRef}
          />
          {loading && (
            <div className='pointer-events-none absolute left-1/2 top-1/2 z-0 -translate-x-1/2 -translate-y-1/2 transform'>
              <svg className={Classes.spinner} viewBox='0 0 50 50'>
                <circle
                  className={Classes.path}
                  cx='25'
                  cy='25'
                  r='20'
                  fill='none'
                  strokeWidth='5'
                ></circle>
              </svg>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
